import { permissionsService } from '../services/permissionsService';

/**
 * QUEM REGISTROU O RECEBIMENTO — um lugar só.
 *
 * `recebimento_registrado_por` e `..._por_id` são obrigatórios no banco e
 * descrevem a AUTORIA do registro: a origem ('user' para quem digitou, 'hook'
 * para o que chega do provedor de pagamento) e o identificador do autor (o
 * `sub` do Cognito, quando é gente).
 *
 * Existiam cinco cópias destas duas linhas — e uma delas, a do modal de
 * entrega do PDV, mandava só a primeira. Os recebimentos nascidos ali ficaram
 * com o autor em branco, e o formulário de edição, que exigia o campo,
 * desabilitava "Salvar" para sempre sem dizer por quê (chamado 2026-0033: a
 * franqueada de Vitacura não conseguia trocar débito por crédito na OS 9758).
 *
 * Por isso é uma função, e não um trecho copiado: quem grava recebimento em
 * qualquer tela chama esta, e as telas não têm como divergir entre si.
 */
export interface AutoriaDoRecebimento {
  recebimento_registrado_por: string;
  recebimento_registrado_por_id: string;
}

/** A autoria de quem está logado. Sem sessão, o id sai vazio — o backend decide. */
export function autoriaDoUsuarioLogado(): AutoriaDoRecebimento {
  return {
    recebimento_registrado_por: 'user',
    recebimento_registrado_por_id: permissionsService.getUser()?.sub || '',
  };
}
